import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../../utils/Methods";
import { IDS } from "../../../../utils/IDS";

//Get All (Read)
export const GetAll = createAsyncThunk(
  "imagetypes/type/get-all",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.Image_Type.Type}?name=${filter?.name || ""}&page=${
          filter?.page || IDS.PAGE
        }&per_page=${filter?.per_page || IDS.PERPAGE}`,
      );
      return res;
    } 
    catch (error) {
      return rejectWithValue(error.message);
    }
  },
);


//Get (Read)
export const GetSingle = createAsyncThunk(
  "imagetypes/type/get",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(`${APIS.Image_Type.Type}/${id}`);
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);



//Create (Add)
export const Create = createAsyncThunk(
  "imagetypes/type/create",
  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(APIS.Image_Type.Type, data);
      return res; // The new tag object
    } 
    
    catch (error) {
      return rejectWithValue(error.message);
    }
  },
);


//Update
export const Update = createAsyncThunk(
  "imagetypes/type/update",
  async ({ id, data }, { rejectWithValue }) => {
    try {
      const res = await PUT(`${APIS.Image_Type.Type}/${id}`, data);
      return res;
    } 
    catch (error) {
      return rejectWithValue(error.message);
    }
  },
);



//Delete
export const Delete = createAsyncThunk(
  "imagetypes/type/delete",
  async (id, { rejectWithValue }) => {
    try {
      const data = await DELETE(`${APIS.Image_Type.Type}/${id}`);
      return id; // Return the id of the deleted bill
    } 
    
    catch (error) {
      return rejectWithValue(error.message);
    }
  },
);


//Status
export const StatusType = createAsyncThunk(
  "imagetypes/type/status",
  async (id, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.Image_Type.Type}/${id}`);
      return res;
    } 
    
    catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const Slice = createSlice({
  name: "type",
  initialState: {
    data: [],
    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,
    status: IDS.SLICESTATUS.Idle,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handling all actions for GetSingle, Create, Update, Delete
      .addCase(GetAll.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAll.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        state.data = action.payload?.data?.data || [];
        state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAll.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetSingle.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetSingle.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(GetSingle.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Create.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Create.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data.unshift(action.payload.data);
      })
      .addCase(Create.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Update.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Update.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        const index = state.data.findIndex(
          (gallerycategory) => gallerycategory.id === action.payload?.data?.id,
        );
        if (index !== -1) {
          state.data[index] = action.payload.data;
        }
      })
      .addCase(Update.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(Delete.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(Delete.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data = state.data.filter(
            (gallerycategory) => gallerycategory.id !== action.payload); // Remove faq cat with the deleted id
      })
      .addCase(Delete.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      //
      .addCase(StatusType.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(StatusType.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data = state.data.filter(
            (gallerycategory) => gallerycategory.id !== action.payload.id); // Remove the faq cat with the deleted id
      })
      .addCase(StatusType.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

// Export actions (if needed in components)
export const {} = Slice.actions;

export default Slice.reducer;
